import React from "react"




export default React.forwardRef((props: any, ref) => {
    return <input name="number" ref={ref} {...props} className="input input-bordered input-sm md:input-md w-full  join-item" placeholder="Telefon numarası" required />

})
